import { Icon, IconProps } from '@chakra-ui/react'

export default function AdministratorKeyIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        d="M7.33333 10H4.66667C3.19391 10 2 11.1939 2 12.6667V13.3333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="7.33268"
        cy="4.66667"
        rx="2.66667"
        ry="2.66667"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6659 11C14.6659 12.2887 13.6212 13.3333 12.3326 13.3333C12.1008 13.3301 11.8708 13.2919 11.6504 13.2201"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.334 8.66602C13.6226 8.66602 14.6673 9.71068 14.6673 10.9993"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1126 11.6796C10.0412 11.4597 10.0032 11.2304 10 10.9993C10 9.71068 11.0447 8.66602 12.3333 8.66602"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1119 11.6797L8.84754 12.946C8.73155 13.063 8.66634 13.2209 8.66602 13.3856V14.0443C8.66602 14.3877 8.94441 14.6661 9.28784 14.6661H9.94935C10.1144 14.6663 10.2727 14.6005 10.3889 14.4832L11.6505 13.2196"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3667 10.9994C12.3666 11.0178 12.3517 11.0327 12.3333 11.0327C12.3149 11.0327 12.3 11.0178 12.3 10.9994C12.3 10.981 12.3149 10.966 12.3333 10.966C12.3421 10.966 12.3506 10.9695 12.3569 10.9758C12.3632 10.982 12.3667 10.9905 12.3667 10.9994"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
